// extracted by mini-css-extract-plugin
module.exports = {"about-container":"LandingPage_about-container__1CCRX"};